import { NeoTaxEnvironment } from '@common/neo.tax';

import { env } from './env';

export const isLocalEnvironment = (): boolean =>
  env.REACT_APP_NEO_TAX_ENV === NeoTaxEnvironment.LOCAL || env.REACT_APP_NEO_TAX_ENV === NeoTaxEnvironment.TEST;

export const isTestMode = (): boolean =>
  env.REACT_APP_NEO_TAX_ENV === NeoTaxEnvironment.TEST || env.REACT_APP_USE_FIREBASE_EMULATOR;

export const isReCaptchaDisabled = (): boolean => env.REACT_APP_DISABLE_RECAPTCHA || isTestMode();

/**
 * Deploy previews share their LaunchDarkly environment with the release branch they mirror, so
 * flags toggled for that branch's deploys (e.g. maintenance mode) also reach the previews.
 */
export const isPreviewEnvironment = (neoTaxEnvironment: NeoTaxEnvironment): boolean =>
  neoTaxEnvironment === NeoTaxEnvironment.DEPLOY_PREVIEW || neoTaxEnvironment === NeoTaxEnvironment.PRODUCTION_PREVIEW;
